const { BX } = window;

export default function (context) {

	const defaultShowWait = BX.showWait;
	const defaultCloseWait = BX.closeWait;

	var lastWait = [];

	BX.showWait = function(node, msg)
	{
		node = BX(node) || document.body || document.documentElement;

		if (BX.findParent(node, {className: 'bibletoday'}))
		{
			var container_id = node.id || Math.random();
			var obMsg = node.bxmsg =  node;

			disable(node);

			lastWait[lastWait.length] = obMsg;
			return obMsg;
		}
		else
		{
			defaultShowWait(node, msg);
		}
	}

	BX.closeWait = function(node, obMsg)
	{
		node = BX(node) || document.body || document.documentElement;

		if (BX.findParent(node, {className: 'bibletoday'}))
		{
			if(node && !obMsg)
				obMsg = node.bxmsg;
			if(node && !obMsg && BX.hasClass(node, 'bx-core-waitwindow'))
				obMsg = node;
			if(node && !obMsg)
				obMsg = BX('wait_' + node.id);
			if(!obMsg)
				obMsg = lastWait.pop();

			if (obMsg && obMsg.parentNode)
			{
				for (var i=0,len=lastWait.length;i<len;i++)
				{
					if (obMsg == lastWait[i])
					{
						lastWait = BX.util.deleteFromArray(lastWait, i);
						break;
					}
				}
			}

			enable(obMsg);

			if (node) node.bxmsg = null;
		}
		else
		{
			defaultCloseWait(node, obMsg);
		}
	}

	function disable(node, spinner = true)
	{
		if (node)
		{
			if (getComputedStyle(node).position == 'static')
				node.style.position = 'relative';

			const element = document.createElement('div');
			element.classList.add('node-disable');
			node.appendChild(element);

			if (spinner)
			{
				element.innerHTML = `
					<div class="spinner-border text-primary" role="status">
						<span class="visually-hidden">Loading</span>
					</div>
				`
			}
		}
	}

	function enable(node)
	{
		node.style.position = '';
		const element = node.querySelector(`.node-disable`);
		if (element)
			element.remove();
	}
}
